import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { Loader2 } from 'lucide-react';
import { z } from 'zod';

import { useGetDashboardStatus } from '~entities/dashboard/api/get-dashboard-status';

import { Dashboard } from '~features/dashboard';

import { throwIfCrashPreviewRequested } from '~shared/observability/crash-preview';
import { crashPreviewSearchParamSchema } from '~shared/observability/crash-preview-search';

const dashboardSearchParamSchema = z.object({
  /** DEV-only: set to `1` to preview the branded CrashScreen. */
  crash: crashPreviewSearchParamSchema,
});

const Component = () => {
  const { crash } = Route.useSearch();
  const { data, isPending } = useGetDashboardStatus();

  // After all hooks — throwing earlier can skip hooks on re-render (Rules of Hooks).
  throwIfCrashPreviewRequested(crash);

  // ENR-2522: do not blank the dashboard on background refetch (was isFetching).
  if (isPending || !data) {
    return (
      <div className='flex h-screen items-center justify-center'>
        <Loader2 className='size-10 animate-spin' />
      </div>
    );
  }

  return (
    <div className='min-h-screen w-full min-w-0 bg-white px-3 py-4 md:p-10'>
      <Dashboard studioData={data} isStudioFetching={false} />
    </div>
  );
};

export const Route = createFileRoute('/_auth/dashboard')({
  validateSearch: zodValidator(dashboardSearchParamSchema),
  component: Component,
});
